import { render, staticRenderFns } from "./exames.vue?vue&type=template&id=6a008268&scoped=true"
import script from "./exames.vue?vue&type=script&lang=js"
export * from "./exames.vue?vue&type=script&lang=js"
import style0 from "./exames.vue?vue&type=style&index=0&id=6a008268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a008268",
  null
  
)

export default component.exports